import React from "react";
import { Input } from "@material-ui/core";
import inputComponentMask from "lib/inputMask";
import { getIntegerFromString } from "utils/getIntegerFromString";
import { ValueTypes } from "pages/refiAnalysis/supervised/constants";
import "./genericValueInputStyles.css";
import _ from "lodash";

const ValueInput = ({
  valueType,
  label,
  name = "",
  placeholder = "",
  value,
  defaultValue,
  setAmount = () => { },
  error,
  minMaxError = true,
  setError = () => { },
  errorMessage,
  isMin = false,
  onBlur = () => { },
  debounceTime
}) => {
  const validateFieldAmount = num => (isMin ? num < defaultValue : num > defaultValue);

  const onChangeValue = event => {
    event.persist();
    const handleChangeDebounce = _.debounce(e => {
      if (e.target.value) {
        const num = getIntegerFromString(e.target.value || 0);
        setError(validateFieldAmount(num) || minMaxError);
        setAmount(num);
      } else {
        setAmount("");
      }
    }, debounceTime || 1000);

    handleChangeDebounce(event);
  };

  const determinePlaceholder = () => {
    switch (valueType) {
      case ValueTypes.currency: return `$ ${placeholder}`;
      case ValueTypes.percent: return `${placeholder}%`;
      default: return "";
    }
  };

  const determineDefaultValue = () => ((valueType === ValueTypes.percent) ? defaultValue * 100 : defaultValue);

  const determineMask = () => {
    switch (valueType) {
      case ValueTypes.integer: return "wholeNumberMask";
      case ValueTypes.percent: return "percentmasknf";
      case ValueTypes.currency: return "currencynocents";
      default: return "wholeNumberMask";
    }
  };

  return (
    <>
      {label && <div className="generic-value-input-label-wrapper">{label}</div>}
      <Input
        fullWidth
        className="generic-value-input-mui-input"
        placeholder={determinePlaceholder()}
        id={`inputFor${name}`}
        defaultValue={determineDefaultValue()}
        value={value}
        onBlur={onBlur}
        inputComponent={inputComponentMask({ mask: determineMask() })}
        onChange={e => onChangeValue(e)}
      />
      {error && <div className="generic-value-input-label-wrapper generic-value-input-error-text">{errorMessage}</div>}
    </>
  );
};

export default ValueInput;
